module.exports = __webpack_public_path__ + "static/media/visa.84ba8b0b.svg";